export class BaseModel {
  protected static userCompanyProfileId = "";

  static setUserCompanyProfileId(value: string) {
    BaseModel.userCompanyProfileId = value;
  }
}
